import axios from 'axios';

const Json2XmlConverter = require('xml-js');

function textOverFlowAdjustment(element) {
  if (element.offsetHeight < 20 || element.offsetWidth < 20) {
    return element;
  }

  while (element.clientHeight > element.firstElementChild.firstElementChild.offsetHeight) {
    element.style.fontSize = `${parseFloat(element.style.fontSize) + 0.1}px`;
  }


  while (element.clientHeight < element.firstElementChild.firstElementChild.offsetHeight) {
    element.style.fontSize = `${parseFloat(element.style.fontSize) - 0.1}px`;
  }
  return element;
}

function applyLineHeightToEachTag(allSpans) {
  for (let spanIndex = 0; spanIndex < allSpans.length; spanIndex++) {
    allSpans[spanIndex].style.lineHeight = `${parseFloat(allSpans[spanIndex].style.fontSize) + this.data.LineSpacing}px`;
  }
  return allSpans;
}
function decreaseFontSize(allSpans, max) {
  for (let i = 0; i < allSpans.length; i++) {
    if (allSpans[i].style.fontSize === '') {
      continue;
    }
    allSpans[i].style.fontSize   = `${parseFloat(allSpans[i].style.fontSize) - parseFloat(allSpans[i].style.fontSize) / max}px`;
    allSpans[i].style.lineHeight = `${parseFloat(allSpans[i].style.fontSize) + this.data.LineSpacing}px`;
  }
  return allSpans;
}
function findMaxFont(allSpans) {
  let maxFontSize = parseFloat(allSpans[0].style.fontSize);
  for (let i = 1; i < allSpans.length; i++) {
    if (parseFloat(allSpans[i].style.fontSize) > maxFontSize) {
      maxFontSize = parseFloat(allSpans[i].style.fontSize);
    }
  }
  return maxFontSize;
}
function rgbToCmyk(RGB) {
  if (typeof RGB === 'string') {
    const strArray = RGB.split(',');
    strArray[0]    = Number(strArray[0].slice(4));
    strArray[1]    = Number(strArray[1]);
    strArray[2]    = Number(strArray[2].slice(0, -1));
    RGB            = {
      r: strArray[0],
      g: strArray[1],
      b: strArray[2],
    };
  }
  let c = 0;
  let m = 0;
  let y = 0;
  let k = 0;

  const r = RGB.r / 255;
  const g = RGB.g / 255;
  const b = RGB.b / 255;

  k = Math.min(1 - r, 1 - g, 1 - b);
  c = (1 - r - k) / (1 - k);
  m = (1 - g - k) / (1 - k);
  y = (1 - b - k) / (1 - k);

  c = Math.round(c * 100);
  m = Math.round(m * 100);
  y = Math.round(y * 100);
  k = Math.round(k * 100);
  // return {
  //   c: c,
  //   m: m,
  //   y: y,
  //   k: k
  // }
  return `cmyk(${c}% ${m}% ${y}% ${k}%)`;
}
function hexToCMYK(hex) {
  let computedC = 0;
  let computedM = 0;
  let computedY = 0;
  let computedK = 0;

  hex = (hex.charAt(0) == '#') ? hex.substring(1, 7) : hex;

  if (hex.length != 6) {
    // alert ('Invalid length of the input hex value!');
    return;
  }
  if (/[0-9a-f]{6}/i.test(hex) != true) {
    // alert ('Invalid digits in the input hex value!');
    return;
  }

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // BLACK
  if (r == 0 && g == 0 && b == 0) {
    computedK = 1;
    return [0, 0, 0, 1];
  }

  computedC = 1 - (r / 255);
  computedM = 1 - (g / 255);
  computedY = 1 - (b / 255);

  const minCMY = Math.min(computedC, Math.min(computedM, computedY));

  computedC = (computedC - minCMY) / (1 - minCMY);
  computedM = (computedM - minCMY) / (1 - minCMY);
  computedY = (computedY - minCMY) / (1 - minCMY);
  computedK = minCMY;
  return `cmyk(${computedC}% ${computedM}% ${computedY}% ${computedK}%)`;
}
function cmykToHex(cmyk) {
  cmyk          = cmyk.replace('cmyk(', '');
  cmyk          = cmyk.replace(')', '');
  cmyk          = cmyk.replace(/%/g, '');
  const cmykArr = cmyk.split(' ');


  let c = parseInt(cmykArr[0]);
  let m = parseInt(cmykArr[1]);
  let y = parseInt(cmykArr[2]);
  let k = parseInt(cmykArr[3]);


  c             = DectoHex(c);
  m             = DectoHex(m);
  y             = DectoHex(y);
  k             = DectoHex(k);
  const cmykHex = `#${c}${m}${y}${k}`;

  return cmykHex;
}
function convertingDifferentMeasurementUnitIntoPx(data) {
  const temp = parseInt(data);
  if (data.endsWith('m')) { return Math.round(temp * 3.77); }
  if (data.endsWith('t')) { return Math.round(temp * 1.33333); }
  return temp;
}
function fetchingSvg(url) {
  return axios
    .get(url)
    .then(async (response) => {
      const svgData    = await response.data;
      const parser     = new DOMParser();
      const doc        = parser.parseFromString(svgData, 'image/svg+xml');
      const svgElement = doc.getElementsByTagName('svg')[0];
      let viewBox      = svgElement.getAttribute('viewBox');
      viewBox          = viewBox.split(' ');
      !svgElement.getAttribute('fill') && svgElement.setAttribute('fill', 'rgb(0,0,0)');
      !svgElement.getAttribute('width') && viewBox[2] && svgElement.setAttribute('width', viewBox[2]);
      !svgElement.getAttribute('height') && viewBox[3] && svgElement.setAttribute('height', viewBox[3]);
      if (svgElement.firstElementChild.tagName.toLowerCase() === 'style') {
        svgElement.removeChild(svgElement.firstElementChild);
      }
      const lines = svgElement.getElementsByTagName('line');
      if (lines.length) {
        for (let lineIndex = 0; lineIndex < lines.length; lineIndex++) {
          lines[lineIndex].style.stroke = '#000000';
        }
      }
      svgElement.style.transformOrigin = 'left top';
      //  this.handleModalClose();
      //   EventBus.$emit('AddSvgShape', {
      //     content: svgElement.outerHTML, name:    this.selectedShape.name, color:   'rgb(0,0,0)', width:   svgElement.getAttribute('width'), height:  svgElement.getAttribute('height'),
      //   });
      return {
        content: svgElement.outerHTML, color:   'rgb(0,0,0)', width:   svgElement.getAttribute('width'), height:  svgElement.getAttribute('height'),
      };
    });
}

function DectoHex(d) {
  return (`0${Number(d).toString(16)}`).slice(-2).toUpperCase();
}
function componentToHex(c) {
  const hex = c.toString(16);
  return hex.length == 1 ? `0${hex}` : hex;
}

function rgbToHex(rgb) {
  rgb     = rgb.split(',');
  const r = parseInt((rgb[0].replace('rgb(', '')).trim());
  const g = parseInt((rgb[1].replace('rgb(', '')).trim());
  const b = parseInt((rgb[2].replace(')', '')).trim());

  return `#${componentToHex(r)}${componentToHex(g)}${componentToHex(b)}`;
}

function hexToRgb(hex) {
  hex          = hex.toUpperCase();
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? `rgb(${parseInt(result[1], 16)},${parseInt(result[2], 16)},${parseInt(result[3], 16)})` : null;
}

function getMaxZIndex(elements) {
  let maxZIndex = 0;
  for (let elementIndex = 0; elementIndex < elements.length; elementIndex++) {
    const elementZIndex = parseInt(elements[elementIndex].style.zIndex);
    if (elementZIndex > maxZIndex) {
      maxZIndex = elementZIndex;
    }
  }
  return maxZIndex;
}

function helperFunctionToSortByObjectKey(prop) {
  return function (a, b) {
    if (a[prop] > b[prop]) {
      return 1;
    } if (a[prop] < b[prop]) {
      return -1;
    }
    return 0;
  };
}
function helperFunctionToReverseSortByObjectKey(prop) {
  return function (a, b) {
    if (a[prop] < b[prop]) {
      return 1;
    } if (a[prop] > b[prop]) {
      return -1;
    }
    return 0;
  };
}

function convertJson2Xml(jsonObj) {
  if (!jsonObj) { return ''; }
  const convert = require('xml-js');
  const options = {
    space:               0,
    compact:             true,
    fullTagEmptyElement: true,
    indentCdata:         false,
    indentAttributes:    false,
    ignoreDeclaration:   false,
    ignoreInstruction:   false,
    ignoreAttributes:    false,
    ignoreComment:       false,
    ignoreCdata:         false,
    ignoreDoctype:       false,
    ignoreText:          false,
  };

  return convert.js2xml(jsonObj, options);
}

async function removeBackground(imageUrl) {
  try {
    const apiUrl = `https://processor.gangifyapp.com/api/removeBg?image=${encodeURIComponent(imageUrl)}`;

    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('API Error:', error);
  }
}

export {
  textOverFlowAdjustment, convertingDifferentMeasurementUnitIntoPx, decreaseFontSize, findMaxFont, cmykToHex, rgbToHex, rgbToCmyk, applyLineHeightToEachTag, hexToRgb, getMaxZIndex, helperFunctionToSortByObjectKey, helperFunctionToReverseSortByObjectKey, convertJson2Xml, fetchingSvg, removeBackground,
};
